import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TriggerService {
  triggerParent$ = new Subject<void>();
  triggerSidebar$ = new Subject<void>();
}
